/**
 * Created by Administrator on 2018/2/24.
 */
const LocalKeys = {
};
const SessionKeys = {
  AUTHORIZED: 'AUTHORIZED',
  TOKEN: 'TOKEN',
  PERMISSION: 'PERMISSION',
  ORGANIZATION: 'ORGANIZATION',
  ORGANIZATIONS: 'ORGANIZATIONS',
  ACCOUNT: "ACCOUNT",
  IMC: 'IMC',
  PROJECT: 'PROJECT',
  MONITORITEM1: 'MONITORITEM1',
  MONITORITEM2: 'MONITORITEM2',
  POINTGROUP: 'POINTGROUP',
  MONITORPOINT1: "MONITORPOINT1",
  MONITORPOINT2: "MONITORPOINT2",
  POINTCHECKLIST: "POINTCHECKLIST",
  GROUPCHECKLIST: "GROUPCHECKLIST",
  SENSORDEVICE1: "SENSORDEVICE1",
  TEMPINFO: 'TEMPINFO',
  AFFILIATES: 'AFFILIATES', // 修改工程隶属机构过滤词
  ADDPOINTNAME: 'ADDPOINTNAME' // 新增学习点名
};

export default {LocalKeys, SessionKeys};



// WEBPACK FOOTER //
// ./src/managers/storage/storage-key.js